// tasks.js - Task definitions and mini-game mechanics

export const TASK_MECHANICS = {
    RHYTHM: 'rhythm',
    DRAG_STACK: 'drag_stack',
    TAP_JUGGLE: 'tap_juggle',
    MEMORY: 'memory',
    QUICK_TAP: 'quick_tap',
    STEALTH: 'stealth',
    OBSTACLE: 'obstacle',
    PUZZLE: 'puzzle',
    AIM: 'aim',
    SEQUENCE: 'sequence'
};

export const ROOMS = {
    // Ground Floor (House)
    KITCHEN: 'kitchen',
    HALLWAY: 'hallway',
    STUDY: 'study',
    LAB: 'lab',
    // Garden Locations
    CARAVAN: 'caravan',
    DOME: 'dome',
    SHED: 'shed',
    LAWN: 'lawn'
};

// Task database - 30 original tasks inspired by the show's silly style
export const TASK_DATABASE = [
    // Kitchen tasks
    {
        id: 'kettle_conundrum',
        title: 'Kettle Conundrum',
        room: ROOMS.KITCHEN,
        description: 'Pour exactly the right amount. Tap to pour. Don\'t overheat!',
        duration: 45,
        mechanic: TASK_MECHANICS.RHYTHM,
        difficulty: 2,
        baseReward: 5,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap rhythmically to pour exactly 40ml. Keep temperature below 80°C.'
    },
    {
        id: 'egg_balance',
        title: 'Egg Balance Extravaganza',
        room: ROOMS.KITCHEN,
        description: 'Balance eggs by tilting your device. Don\'t drop any!',
        duration: 60,
        mechanic: TASK_MECHANICS.STEALTH,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Move slowly to balance 3 eggs. Sudden movements will crack them.'
    },
    {
        id: 'spoon_symphony',
        title: 'Spoon Symphony',
        room: ROOMS.KITCHEN,
        description: 'Play the spoons in the right order to create music.',
        duration: 40,
        mechanic: TASK_MECHANICS.SEQUENCE,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap the spoons in the sequence shown. Speed increases each round.'
    },

    // Lab tasks
    {
        id: 'lab_mix_up',
        title: 'Lab Mix-Up',
        room: ROOMS.LAB,
        description: 'Mix ingredients in the correct order. Wrong mixes explode!',
        duration: 60,
        mechanic: TASK_MECHANICS.PUZZLE,
        difficulty: 3,
        baseReward: 8,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Follow the color-coded recipe. Mix 3 ingredients correctly.'
    },
    {
        id: 'beaker_bounce',
        title: 'Beaker Bounce',
        room: ROOMS.LAB,
        description: 'Bounce the molecule into the beaker. Tap to launch!',
        duration: 50,
        mechanic: TASK_MECHANICS.AIM,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap when the power meter is in the green zone.'
    },
    {
        id: 'microscope_madness',
        title: 'Microscope Madness',
        room: ROOMS.LAB,
        description: 'Spot the different microbe among the identical ones.',
        duration: 35,
        mechanic: TASK_MECHANICS.QUICK_TAP,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Find the one different microbe before time runs out!'
    },

    // Study tasks
    {
        id: 'paper_pyramid',
        title: 'Paper Pyramid',
        room: ROOMS.STUDY,
        description: 'Stack falling papers to match the target silhouette.',
        duration: 75,
        mechanic: TASK_MECHANICS.DRAG_STACK,
        difficulty: 3,
        baseReward: 8,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Drag papers to stack them. Match the shadow shape exactly.'
    },
    {
        id: 'typewriter_test',
        title: 'Typewriter Test',
        room: ROOMS.STUDY,
        description: 'Type the silly sentences as they appear. Speed counts!',
        duration: 50,
        mechanic: TASK_MECHANICS.QUICK_TAP,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap the letters as they light up. Don\'t miss any!'
    },
    {
        id: 'bookshelf_sort',
        title: 'Bookshelf Sorting',
        room: ROOMS.STUDY,
        description: 'Arrange books by ridiculous criteria. Tallest to shortest!',
        duration: 55,
        mechanic: TASK_MECHANICS.PUZZLE,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Drag books to sort them. Criteria changes each round!'
    },

    // Hallway tasks
    {
        id: 'hallway_hush',
        title: 'Hallway Hush',
        room: ROOMS.HALLWAY,
        description: 'Sneak quietly. Release at the right moment to stay silent.',
        duration: 65,
        mechanic: TASK_MECHANICS.STEALTH,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Hold to move, release during quiet moments. Don\'t make noise!'
    },
    {
        id: 'portrait_puzzle',
        title: 'Portrait Puzzle',
        room: ROOMS.HALLWAY,
        description: 'Arrange portrait pieces to reveal the mysterious figure.',
        duration: 70,
        mechanic: TASK_MECHANICS.PUZZLE,
        difficulty: 3,
        baseReward: 8,
        wellnessBonus: 3,
        wellnessPenalty: -1,
        instructions: 'Drag pieces to complete the portrait. Edges must match!'
    },

    // Study tasks
    {
        id: 'paper_pyramid',
        title: 'Paper Pyramid',
        room: ROOMS.STUDY,
        description: 'Stack falling papers to match the target silhouette.',
        duration: 75,
        mechanic: TASK_MECHANICS.DRAG_STACK,
        difficulty: 3,
        baseReward: 8,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Drag papers to stack them. Match the shadow shape exactly.'
    },
    {
        id: 'typewriter_test',
        title: 'Typewriter Test',
        room: ROOMS.STUDY,
        description: 'Type the silly sentences as they appear. Speed counts!',
        duration: 50,
        mechanic: TASK_MECHANICS.QUICK_TAP,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap the letters as they light up. Don\'t miss any!'
    },
    {
        id: 'bookshelf_sort',
        title: 'Bookshelf Sorting',
        room: ROOMS.STUDY,
        description: 'Arrange books by ridiculous criteria. Tallest to shortest!',
        duration: 55,
        mechanic: TASK_MECHANICS.PUZZLE,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Drag books to sort them. Criteria changes each round!'
    },

    // Caravan tasks (Cozy, cramped indoor challenges)
    {
        id: 'caravan_juggle',
        title: 'Caravan Juggling',
        room: ROOMS.CARAVAN,
        description: 'Keep 3 objects airborne in the cramped caravan!',
        duration: 50,
        mechanic: TASK_MECHANICS.TAP_JUGGLE,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Tap objects to keep them up. Red is heavy, blue is bouncy!'
    },
    {
        id: 'caravan_clean',
        title: 'Caravan Spring Clean',
        room: ROOMS.CARAVAN,
        description: 'Shake your device to dust everything in the caravan!',
        duration: 40,
        mechanic: TASK_MECHANICS.RHYTHM,
        difficulty: 2,
        baseReward: 5,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Shake rapidly! Clean 100% before time runs out.'
    },
    {
        id: 'caravan_stack',
        title: 'Caravan Storage Stack',
        room: ROOMS.CARAVAN,
        description: 'Stack items without making them topple in the caravan!',
        duration: 55,
        mechanic: TASK_MECHANICS.DRAG_STACK,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Drag items to stack them. Keep the tower stable!'
    },

    // Dome tasks (Grand theatrical performance tasks)
    {
        id: 'dome_performance',
        title: 'Dome Performance Sequence',
        room: ROOMS.DOME,
        description: 'Execute the perfect performance sequence in the dome!',
        duration: 50,
        mechanic: TASK_MECHANICS.SEQUENCE,
        difficulty: 3,
        baseReward: 8,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Repeat the sequence shown. Grow longer each round!'
    },
    {
        id: 'dome_memory',
        title: 'Taskmaster\'s Memory Test',
        room: ROOMS.DOME,
        description: 'Remember the pattern shown in the dome. Impress the Taskmaster!',
        duration: 45,
        mechanic: TASK_MECHANICS.MEMORY,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Watch the pattern, then repeat it perfectly!'
    },
    {
        id: 'dome_rhythm',
        title: 'Dome Spotlight Dance',
        room: ROOMS.DOME,
        description: 'Hit your marks in rhythm under the spotlight!',
        duration: 40,
        mechanic: TASK_MECHANICS.RHYTHM,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap in rhythm to the beat. Don\'t miss a step!'
    },

    // Shed tasks (Tool-based challenges)
    {
        id: 'shed_sprint',
        title: 'Shed Sprint',
        room: ROOMS.SHED,
        description: 'Dodge falling tools and collect useful items!',
        duration: 50,
        mechanic: TASK_MECHANICS.OBSTACLE,
        difficulty: 3,
        baseReward: 8,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Swipe left/right to dodge. Collect green items, avoid red!'
    },
    {
        id: 'tool_sort',
        title: 'Tool Sorting Challenge',
        room: ROOMS.SHED,
        description: 'Put each tool back in its correct shadow on the wall.',
        duration: 55,
        mechanic: TASK_MECHANICS.PUZZLE,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Drag tools to matching shadows. Complete all 8 tools!'
    },
    {
        id: 'hammer_rhythm',
        title: 'Hammer Time Challenge',
        room: ROOMS.SHED,
        description: 'Hit the nails in perfect rhythm. Don\'t miss a beat!',
        duration: 45,
        mechanic: TASK_MECHANICS.RHYTHM,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap when the hammer reaches the nail. Perfect timing!'
    },

    // Lawn tasks (Outdoor sports & physical activities)
    {
        id: 'lawn_throw',
        title: 'Target Throwing Challenge',
        room: ROOMS.LAWN,
        description: 'Hit all the targets on the lawn with perfect throws!',
        duration: 60,
        mechanic: TASK_MECHANICS.AIM,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Drag to aim, release to throw. Hit all 5 targets!'
    },
    {
        id: 'lawn_sprint',
        title: 'Lawn Sprint Challenge',
        room: ROOMS.LAWN,
        description: 'Sprint across the lawn as fast as possible!',
        duration: 45,
        mechanic: TASK_MECHANICS.QUICK_TAP,
        difficulty: 2,
        baseReward: 6,
        wellnessBonus: 2,
        wellnessPenalty: -1,
        instructions: 'Tap alternating buttons as fast as you can. Sprint!'
    },
    {
        id: 'lawn_juggle',
        title: 'Garden Ball Juggling',
        room: ROOMS.LAWN,
        description: 'Keep the ball in the air on the lawn. Don\'t let it drop!',
        duration: 50,
        mechanic: TASK_MECHANICS.TAP_JUGGLE,
        difficulty: 3,
        baseReward: 7,
        wellnessBonus: 3,
        wellnessPenalty: -2,
        instructions: 'Tap the ball to keep it airborne. Time your taps perfectly!'
    }
];

// Task manager class
export class TaskManager {
    constructor(gameState) {
        this.gameState = gameState;
        this.availableTasks = [];
        this.updateAvailableTasks();
    }

    // Get tasks available based on unlocked rooms and difficulty progression
    updateAvailableTasks() {
        const unlockedRooms = this.gameState.house.unlockedRooms || [ROOMS.KITCHEN, ROOMS.HALLWAY, ROOMS.STUDY, ROOMS.LAB];
        const playerLevel = this.gameState.progression?.level || 1;

        // Filter tasks by unlocked rooms and appropriate difficulty
        this.availableTasks = TASK_DATABASE.filter(task => {
            const roomUnlocked = unlockedRooms.includes(task.room);
            const difficultyOk = task.difficulty <= Math.min(playerLevel + 1, 5);
            const notRecentlyCompleted = !this.wasRecentlyCompleted(task.id);

            return roomUnlocked && difficultyOk && notRecentlyCompleted;
        });
    }

    wasRecentlyCompleted(taskId) {
        const completed = this.gameState.tasks.completed || [];
        const recent = completed.slice(-5); // Last 5 completed tasks
        return recent.includes(taskId);
    }

    // Get a random task for a specific room
    getTaskForRoom(roomId) {
        const roomTasks = this.availableTasks.filter(t => t.room === roomId);
        if (roomTasks.length === 0) return null;

        return roomTasks[Math.floor(Math.random() * roomTasks.length)];
    }

    // Get a completely random task
    getRandomTask() {
        if (this.availableTasks.length === 0) {
            this.updateAvailableTasks();
        }

        if (this.availableTasks.length === 0) return null;

        return this.availableTasks[Math.floor(Math.random() * this.availableTasks.length)];
    }

    // Get task by ID
    getTaskById(taskId) {
        return TASK_DATABASE.find(t => t.id === taskId);
    }

    // Calculate score based on performance
    calculateScore(task, accuracy, timeBonus) {
        let score = task.baseReward;

        // Accuracy bonus (0-3 points)
        score += Math.floor(accuracy * 3);

        // Time bonus (0-2 points)
        score += Math.floor(timeBonus * 2);

        return Math.min(score, 10); // Cap at 10
    }

    // Should we issue a new task?
    shouldIssueTask(gameState) {
        const currentTime = Date.now();
        const lastTaskTime = gameState.tasks.lastTaskTime;

        if (!lastTaskTime) return true;

        // Issue new task every 5-10 minutes (configurable)
        const minInterval = 5 * 60 * 1000; // 5 minutes
        const timeSince = currentTime - lastTaskTime;

        return timeSince >= minInterval;
    }

    // Get room-specific decoration/atmosphere info
    getRoomInfo(roomId) {
        const roomData = {
            // Ground Floor (House)
            [ROOMS.KITCHEN]: { color: '#F4E8C1', description: 'Warm tiles and humming appliances' },
            [ROOMS.HALLWAY]: { color: '#A0A0A0', description: 'Echoing footsteps and portrait-lined walls' },
            [ROOMS.STUDY]: { color: '#8B7355', description: 'Dusty books and creaky desk chairs' },
            [ROOMS.LAB]: { color: '#6B6B6B', description: 'Bubbling beakers and scientific chaos' },
            // Garden Locations
            [ROOMS.CARAVAN]: { color: '#C8B299', description: 'Cozy and slightly cramped' },
            [ROOMS.DOME]: { color: '#E0E0E0', description: 'Echoing acoustics and curved walls' },
            [ROOMS.SHED]: { color: '#6B4423', description: 'Tools hanging and sawdust in the air' },
            [ROOMS.LAWN]: { color: '#4CAF50', description: 'Fresh grass and open sky' }
        };

        return roomData[roomId] || { color: '#FFFFFF', description: 'A mysterious location' };
    }
}
